import {Router} from '@angular/router';
import Swal from 'sweetalert2';
import {TranslateService} from "@ngx-translate/core";
import {GridView} from "../model/grid";
import * as moment from "moment/moment";
import {ValidationErrors} from "@angular/forms";

declare var $: any;

export class BaseComponent {

  labels: any = {
    previousLabel: '',
    nextLabel: '',
    screenReaderPaginationLabel: 'Pagination',
    screenReaderPageLabel: 'page',
    screenReaderCurrentLabel: `You're on page`
  };

  gridView: GridView = {
    col1: '8.333333',
    col2: '16.666667',
    col3: '25',
    col4: '33.333333',
    col5: '41.666667',
    col6: '50',
    col7: '58.333333',
    col8: '66.666667',
    col9: '75',
    col10: '83.333333',
    col11: '91.666667',
    col12: '100',
  }
  language: string = '';

  constructor(public router: Router,
              public translate: TranslateService) {
  }

  /*setCulture(culture: string) {
    localStorage.setItem('culture', culture);
  }*/
  set accessCulture(param: string) {
    localStorage.setItem('culture', param);
  }

  get accessCulture(): string {
    return localStorage.getItem('culture') ?? '';
  }

  set accessLanguage(param: string) {
    localStorage.setItem('language', param);
  }

  get accessLanguage(): string {
    return localStorage.getItem('language') ?? '';
  }

  handlerCultureLanguage(language: string) {
    this.language = language;
    this.accessCulture = language;
    this.accessLanguage = language;
    this.translate.use(language);
    console.log('language');
    console.log(language);
  }

  showMessage(t: string, m: string, type: any = 'warning') {
    Swal.fire({
      title: t,
      html: m,
      icon: type,
      confirmButtonColor: '#032E58',
    });
  }

  onError(error: any) {
    if (error.status === 401) {
      localStorage.removeItem('token');
      this.router.navigate(['/login']);
      return;
    } else {
      this.showMessage('Atenção!', error.message, 'warning');
      return;
    }
  }

  onErrorRest(error: any) {
    const e = JSON.parse(error);
    if (e.statusCode === 401) {
      this.router.navigate(['/login']);
      return;
    }

    if (e.statusCode === 404) {
      this.showMessage('Atenção!', e.message, 'warning');
      return;
    }

    if (e.statusCode === 400) {
      this.showMessage('Atenção!', e.message, 'warning');
      return;
    }

    if (e.statusCode === 500) {
      this.showMessage('Atenção!', 'Ops.. ocorreu um erro inesperado.', 'warning');
      return;
    }
  }

  setToken(token: string) {
    localStorage.setItem('token', token);
  }


  confirmMessage(t: string, m: string, callback: any = null) {
    Swal.fire({
      title: t,
      text: m,
      icon: 'warning',
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      confirmButtonColor: '#032E58',
      cancelButtonColor: '#dc3545'
    }).then((result) => {
      if (!this.isNullOrUndefined(result.value) && result.value === true) {
        if (callback != null) {
          callback();
        }
      }
    });
  }

  isNullOrUndefined(value: any, object = false) {
    if (object) {
      return typeof value === 'undefined' || value == null;
    }
    return typeof value === 'undefined' || value == null || value.length === 0;
  }

  toggleLoader(b: boolean): void {
    if (!b) {
      $('#loaderBox').stop().fadeOut();
    } else {
      $('#loaderBox').stop().fadeIn();
    }
  }

  getErrorMessage(s: string) {
    return s === 'required' ? 'Campo obrigatório' : 'Campo inválido';
  }

  getDateFormatString(p: string): string {
    if (p === 'pt-BR') {
      return 'DD/MM/YYYY';
    } else {
      return 'MM/DD/YYYY';
    }
    // return '';
  }

  getNameFile(name: string) {
    return name + '-' + moment().utc(true).format('yyyy-MM-DD') + '.xlsx';
  }

  permissionPageAdmin(profile: string) : boolean {
    return profile === 'admin';
  }

  getErrorDinamic(s: ValidationErrors | null) {
    const result = (Object.keys(s ?? {}) as (keyof typeof s)[])[0];
    switch (result) {
      case 'email':
        return 'E-mail inválido';
      case 'pattern':
        return 'Campo inválido'
      default:
        return 'Campo obrigatório';
    }
  }
}


